module.exports = __webpack_public_path__ + "static/overview-portrait-2@2x-10d97bcde70638892f6716e61701c88d.jpg";